<template>
  <aside class="sidebar" :class="{ 'is-collapsed': collapsed }">
    <div class="sidebar__brand">
      <span class="sidebar__mark">A</span>
      <div v-show="!collapsed" class="sidebar__brand-copy">
        <strong>智能云剪辑</strong>
        <small>让短视频创作更简单</small>
      </div>
    </div>
    <el-scrollbar class="sidebar__scroll">
      <el-menu :default-active="$route.path" :collapse="collapsed" :collapse-transition="false" router unique-opened background-color="transparent" text-color="#aeb9ca" active-text-color="#ffffff">
        <sidebar-item v-for="route in menuRoutes" :key="route.path" :route="route" />
      </el-menu>
    </el-scrollbar>
  </aside>
</template>

<script>
import { asyncRoutes } from '@/router';
import SidebarItem from './SidebarItem.vue';

export default {
  name: 'AppSidebar',
  components: { SidebarItem },
  computed: {
    collapsed() {
      return this.$store.state.app.preferences.sidebarCollapsed;
    },
    roles() {
      return this.$store.state.user.roles;
    },
    hiddenMenus() {
      return this.$store.state.app.preferences.hiddenMenus || [];
    },
    menuRoutes() {
      return this.filterRoutes(asyncRoutes);
    }
  },
  methods: {
    filterRoutes(routes, parentPath = '') {
      return routes.reduce((items, route) => {
        if (route.meta && route.meta.hidden) return items;
        if (route.meta && route.meta.roles && !route.meta.roles.some((role) => this.roles.includes(role))) return items;
        const routePath = route.path.startsWith('/') ? route.path : `${parentPath}/${route.path}`.replace(/\/+/g, '/');
        if (this.hiddenMenus.includes(routePath)) return items;
        const next = { ...route };
        if (route.children) next.children = this.filterRoutes(route.children, routePath);
        items.push(next);
        return items;
      }, []);
    }
  }
};
</script>
